module.exports = __webpack_public_path__ + "img/9788957076378.5e0a351f.jpg";